import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const images = [
  { src: "/images/impressionen/Schneepiste.jpg",                              alt: "Schneepiste",    title: "Schneepiste" },
  { src: "/images/impressionen/Praeparierung.jpeg",                           alt: "Präparierung",   title: "Präparierung" },
  { src: "/images/impressionen/Skidu.jpeg",                                   alt: "Skidu",          title: "Skidu" },
  { src: "/images/impressionen/Huettenwagen.jpg",                             alt: "Hüttenwagen",    title: "Hüttenwagen" },
  { src: "/images/impressionen/Wagen.jpg",                                    alt: "Wagen",          title: "Hüttenwagen" },
  { src: "/images/impressionen/IMG_0132.jpg",                                 alt: "Impression",     title: "Impression" },
  { src: "/images/impressionen/IMG_0133.jpg",                                 alt: "Impression",     title: "Impression" },
  { src: "/images/impressionen/IMG_0138.jpg",                                 alt: "Impression",     title: "Impression" },
  { src: "/images/impressionen/0986772f-ce02-4eec-883a-9beade638f41.JPG",    alt: "Impression",     title: "Impression" },
  { src: "/images/impressionen/65e007d5-60dc-4b0b-8290-04626c2a2e65.JPG",    alt: "Impression",     title: "Impression" },
  { src: "/images/impressionen/7e450121-3af9-4e83-89f5-cd0bedf9a953.JPG",    alt: "Impression",     title: "Impression" },
  { src: "/images/impressionen/d37c843d-bdb9-4a9c-b892-fe9e9cd24a73.JPG",    alt: "Impression",     title: "Impression" },
  { src: "/images/impressionen/f941a435-a1d9-4050-8012-f3aa3666ed33.JPG",    alt: "Impression",     title: "Impression" },
  { src: "/images/impressionen/fda3f54a-ce75-43e6-84a3-1e0574870385.JPG",    alt: "Impression",     title: "Impression" },
];

const SmoothGallery = () => {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const openLightbox = (i) => {
    setPhotoIndex(i);
    setIsOpen(true);
  };

  return (
    <div className="app-container">
      <div className="impressionen-content">
        <h1 className="title">Impressionen</h1>
        <p style={{ textAlign: 'center', color: 'var(--light-text)', marginBottom: '2rem' }}>
          Ein Blick hinter die Kulissen — Bilder aus dem Vereinsleben des Schiclub Buch.
        </p>

        <div className="image-grid">
          {images.map((image, i) => (
            <div
              className="image-container"
              key={i}
              onClick={() => openLightbox(i)}
              title={image.title}
            >
              <img src={image.src} alt={image.alt} />
              <div className="image-title">{image.title}</div>
            </div>
          ))}
        </div>

        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex].src}
            nextSrc={images[(photoIndex + 1) % images.length].src}
            prevSrc={images[(photoIndex + images.length - 1) % images.length].src}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
            onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
            imageCaption={images[photoIndex].title}
          />
        )}
      </div>
    </div>
  );
};

export default SmoothGallery;
